import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeliveryMode } from '@spartacus/cart/base/root';
import { CheckoutAdapter } from '@spartacus/checkout/base/core';
import {
  Address,
  ConverterService,
  InterceptorUtil,
  OCC_USER_ID_ANONYMOUS,
  Occ,
  OccEndpointsService,
  PaymentDetails,
  USE_CLIENT_TOKEN,
} from '@spartacus/core';
import { ORDER_NORMALIZER, Order } from '@spartacus/order/root';
import { Observable } from 'rxjs';

// To be changed to a more optimised params after ticket: C3PO-1076
const FULL_PARAMS = 'fields=FULL';
const CHECKOUT_PARAMS = 'FULL';
const ORDERS_ENDPOINT = '/orders';
const CARTS_ENDPOINT = '/carts/';
interface CheckoutDetails {
  deliveryAddress: Address;
  deliveryMode: DeliveryMode;
  paymentInfo: PaymentDetails;
  minDeliveryDate: string;
  minLeadTimeOutOfStock: string;
}
@Injectable()
export class OccCheckoutAdapter implements CheckoutAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {}

  protected getEndpoint(userId: string, subEndpoint: string): string {
    const orderEndpoint = 'users/' + userId + subEndpoint;
    return this.occEndpoints.buildUrl(orderEndpoint);
  }

  public placeOrder(userId: string, cartId: string): Observable<Order> {
    const url = this.getEndpoint(userId, ORDERS_ENDPOINT);
    const params = new HttpParams({
      fromString: 'cartId=' + cartId + '&' + FULL_PARAMS,
    });

    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    return this.http.post<Occ.Order>(url, {}, { headers, params }).pipe(this.converter.pipeable(ORDER_NORMALIZER));
  }

  getCheckoutDetails(userId: string, cartId: string): Observable<CheckoutDetails> {
    const url = this.getEndpoint(userId, CARTS_ENDPOINT) + cartId;
    const params = new HttpParams({
      fromString: `fields=${CHECKOUT_PARAMS}`,
    });
    return this.http.get<CheckoutDetails>(url, { params });
  }

  clearCheckoutDeliveryAddress(userId: string, cartId: string): Observable<any> {
    const url = `${this.getEndpoint(userId, CARTS_ENDPOINT)}${cartId}/addresses/delivery`;
    return this.http.delete<any>(url);
  }

  clearCheckoutDeliveryMode(userId: string, cartId: string): Observable<any> {
    const url = `${this.getEndpoint(userId, CARTS_ENDPOINT)}${cartId}/deliverymode`;
    return this.http.delete<any>(url);
  }
}
